import React from 'react'
import styled from 'styled-components'
import css from '@styled-system/css'

import { Flex, H4, P } from 'ui/bend'
import { ResponsiveSVG } from 'ui/acro'
import { useUserContext } from 'context'
import { storeEventInLocalStorage } from 'gtm/pushEvents'
import { AloAccessUserLevelAndPoints } from './AloAccessUserLevelAndPoints'
import FilterIcon from '../../../../assets/images/filter.svg'
import CoachmarkRenderer from 'components_v1/CoachMarkRenderer'

const HeaderSection = styled(Flex)(() =>
  css({
    justifyContent: 'space-between',
    alignItems: ['stretch', 'center']
  })
)

const NameHeader = styled(H4)(() =>
  css({
    letterSpacing: '-0.72px',
    fontWeight: '400'
  })
)

const PreferenceLink = styled(P)(() =>
  css({
    letterSpacing: '0.352px',
    textDecorationLine: 'underline',
    textDecorationSkipInk: 'none',
    textUnderlinePosition: 'from-font'
  })
)

const MyPreferencesWrapper = styled(Flex)({
  gap: '6px',
  cursor: 'pointer',
  alignItems: 'center',
  textTransform: 'uppercase'
})

export const WelcomeHeader = () => {
  const { user, contextData } = useUserContext()

  const myPreferencesClick = () =>
    storeEventInLocalStorage({
      event: 'my_preferences_click',
      first_time: !contextData?.user_answered_survey,
      location: 'homepage'
    })

  return (
    <>
      <Flex style={{ flexDirection: 'column', gap: '18px' }}>
        <HeaderSection>
          {['tier1', 'tier2', 'tier3'].includes(user?.userAloTier) ? (
            <AloAccessUserLevelAndPoints />
          ) : (
            <NameHeader>Hello, {user.firstName}</NameHeader>
          )}
          <PreferenceLink
            onClick={myPreferencesClick}
            as='a'
            href='/surveys/onboarding?start=true'
          >
            <MyPreferencesWrapper id='my-preferences'>
              <ResponsiveSVG SVG={FilterIcon} width='20px' height='20px' />
              My Preferences
            </MyPreferencesWrapper>
          </PreferenceLink>
        </HeaderSection>
      </Flex>
      {user?.createdAt && <CoachmarkRenderer page='home' user={user} />}
    </>
  )
}
